import { useDropdownContext } from '../../context/DropdownContext';
import { type FlatItem } from '../../types';
import { styles } from './styles';

export const ItemContent = ({ item }: { item: FlatItem }) => {
  const { renderItemContent } = useDropdownContext();

  if (renderItemContent) {
    return renderItemContent(item);
  }

  return (
    <>
      <span>{item.label}</span>
      {item.description && <span css={styles.Description}>{item.description}</span>}
    </>
  );
};
